import React, {useState} from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useDocument } from '../../Data/Documents';
import { PageLoading } from '../../Components/Loading';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import Form, { Actions, Wysiwyg } from '../../Components/Form';
import TemplateOptions from './TemplateOptions';
import Button from '../../Components/Button/Button';

const Document = () => {
    const {documentId} = useParams();
    const {document, updateDocument, generateDocument, refresh, checkForGenerationComplete} = useDocument(documentId);

    return <>
        <TopBar left="BackBtn" title={document ? document.title : 'Document'} />
        <Page>
            {document ? <Inner {...{document, updateDocument, generateDocument, refresh, checkForGenerationComplete}} /> : <PageLoading />}
        </Page>
    </>
}

const Inner = (params) => {
    switch(params.document.source) {
        case 'Upload':
            return <Navigate to={`/business/documents`} />
        case 'Template':
            return <Template {...params} handleSave={params.updateDocument} />
        case 'Custom':
            return <Custom {...params} handleSave={params.updateDocument} />
        default:
            return <p className="text-muted text-center">Unknown source</p>
    }
}

const Template = ({document, handleSave, generateDocument, refresh, checkForGenerationComplete}) => {
    const [templateOpen, setTemplateOpen] = useState(document.content === null);

    return <>
        {/* Ensure the form re-draws with the new content after it's generated */}
        <Form key={document.content} data={document} onSubmit={handleSave}>
            <TheWysiwyg />
            <Actions submit={{label: 'Save'}}
                left={<Button theme="secondary" icon="FileCheck" label="Recreate" onClick={() => setTemplateOpen(true)} />}
            />
        </Form>
        <TemplateOptions {...{
            isOpen: templateOpen,
            setIsOpen: setTemplateOpen,
            document,
            generateDocument,
            refresh: refresh,
            checkForGenerationComplete: checkForGenerationComplete
        }} />
    </>
}

const Custom = ({document, handleSave}) => {
    document.templateOptions = null;
    return <Form data={document} onSubmit={handleSave}>
        <TheWysiwyg />
        <Actions submit={{label: 'Save'}} />
    </Form>
}

const TheWysiwyg = () => {
    return <Wysiwyg name="content"
        label="Document"
        imageTags={[{name: 'Documents', value: 'Image'}]}
        previousTags={[{name: 'Logo', value: 'Standard'}]}
        bottomMargin={100}
        features={['images', 'basicFormatting', 'moreFormatting', 'advancedFormatting']}
    />
}

export default Document;
